import { AspectRatioBox, getVideoIDFromUrl, Icon, Video } from '..'
import React, { useState } from 'react'
import cn from 'classnames'

export type VideoSectionProps = {
  url: string
  onRenderImage?: () => JSX.Element
  description?: string
  caption?: string
  autoplay?: boolean
}

const VideoSection = ({ description, url, onRenderImage, caption, autoplay = false }: VideoSectionProps) => {
  const [playing, setPlaying] = useState(autoplay)
  const validVideo = getVideoIDFromUrl(url)

  return (
    <div className='page-slice-spacer container video-section position-relative'>
      {description && <div className='pb-2' dangerouslySetInnerHTML={{ __html: description }} />}

      <button
        onClick={() => setPlaying(true)}
        className={cn('w-100 video-section__thumbnail')}
        aria-label='Play video'
      >
        <AspectRatioBox ratio='widescreen'>
          <div className='video-section__video'>
            {validVideo.service ? (
              <Video video={validVideo} />
            ) : (
              <video
                muted
                playsInline
                className={cn('h-100 video-feature__video', {
                  'video-feature__video--appear': playing
                })}
                src={url}
                autoPlay={playing}
                loop={autoplay}
              />
            )}
          </div>
          {onRenderImage && !playing && onRenderImage()}
          {!playing && (
            <Icon
              style={{ height: '70px', width: '70px' }}
              containerClass='h-100 w-100 completeCenter'
              type='play'
            />
          )}
        </AspectRatioBox>
      </button>

      {caption && <p className='video-section__caption'>{caption}</p>}
    </div>
  )
}

export default VideoSection
